// extracted by mini-css-extract-plugin
export var textInput = "_hg-0";